import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

const QUERY = gql`
  query seasons($projectId: Int!) {
    project(id: $projectId) {
      id
      seasons {
        id
        label
      }
    }
  }
`;

const useSeasons = projectId => {
  const { error, loading, data } = useQuery(QUERY, {
    skip: !projectId,
    // NOTE Project.id is listed in the schema as an ID! type, but the project
    // query takes a projectId of type Int! Obviously, this is wrong.
    variables: { projectId: parseInt(projectId) },
  });
  return { error, loading, data: data?.project.seasons };
};

export default useSeasons;
